import { render, staticRenderFns } from "./alipayStatus.vue?vue&type=template&id=d47338ec"
import script from "./alipayStatus.vue?vue&type=script&lang=js"
export * from "./alipayStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports